import { useState,useEffect } from 'react'; 
import Box from '@mui/material/Box';
import { Button, Stack } from '@mui/material';
import { ConstructionRounded } from '@mui/icons-material';
import AutoFixNormal from '@mui/icons-material/AutoFixNormal';
import CanvasDraw from 'react-canvas-draw';
import {Slider,Typography}  from '@mui/material';
import { ClockLoader } from 'react-spinners';

import { IMAGESERVICEURL } from './SinglePage';

const minDistance = 10;

//const baseurl = "http://localhost:8181/cxf/eyeprocessor/lastfastsam/image/";
//const IMAGESERVICEURL = "http://localhost:8181/cxf/eyeprocessor/";


const InpaintEditor = ({dim, show}) => {
  
  const [dims, setDims] = useState([dim,dim]);
  const [brush, setBrush] = useState(20);
  const [canvasobj, setCanvasObj] = useState();
  const [busy, setBusy] = useState(false);
  const [history,setHistory] = useState();
  const [ready, setReady] = useState(false);

  const src = IMAGESERVICEURL+"maskcenter/"+show;

  //const [src,setSrc] = useState(basesrc);
  
  useEffect(()=>{
    if(canvasobj!==undefined){
      if(history!==undefined){
        clear();
        canvasobj.image.src = IMAGESERVICEURL+"newinpaint/"+history;
      }
    }
  },[history]);


  if(dim===undefined || show===undefined){
    return (<></>);
  }
  
  const scale = (val)=>{
    return dim*val/100;
  }

  /*const patchReady = (id)=>{
    fetch(IMAGESERVICEURL+"patchready/"+id)
    .then((res) =>{ 
      return res.json();
    })
    .then( status => {
      if(status===true){ 
        //clearInterval(waitpatch);
        setReady(true);
      }else{
        setTimeout(()=>patchReady(id),1000);
      }
    })
    .catch(()=>{
      console.log("err on patch sens");
      //clearInterval(waitpatch);
    });
  }*/

  
  
  const showdim = (e)=>{
    console.log("dimensions "+e.target.naturalHeight+" x "+e.target.naturalWidth);
    setDims([e.target.naturalWidth,e.target.naturalHeight]);
  }

  function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);

    const length = binaryString.length;
    const bytes = new Uint8Array(length);

    for (let i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  const submit = (e)=>{
    //let img = document.getElementById("baseimg");
    let formData = new FormData();
    const myBuffer = canvasobj.getDataURL('PNG',true,0).split(",")[1];
    if(history!==undefined)
      formData.append("lastmask", history );
    else
      formData.append("lastmask", null );
    formData.append("base64", myBuffer );
    formData.append("srcimageid", show );
    
    setBusy(true);
    fetch(IMAGESERVICEURL+"newinpaint",{
        method:"POST",
        body:formData
    }).then((response)=> response.json())
    .then((data)=>{
      setBusy(false);
      if((data.mask!=undefined)&&(data.mask!=null))
        setHistory(data.mask);
      console.log("inpaint done for ",data);  
    })
    .catch((error)=>{
      setBusy(false);
      console.log("error "+error);
            
    });
  }
  const reset = ()=>{
    setHistory(undefined);
    canvasobj.image.src = src;
  }

  const clear = ()=>{
    canvasobj.clear();
  }

  const undo = ()=>{
    canvasobj.undo();
  }

  const changes = (mask)=>{

    console.log(mask);
    
    //let imgmask = getDataURL("PNG",false,0);

    
    //var lines = mask.lines.map( line => line.points)
  
    //var ratioy = dimension.h / dimension.ch;
    //var ratiox = dimension.w / dimension.cw;
    //var ratiox = 1.0;
    //var ratioy = 1.0;

    //var pi = lines.map( point => {
    //  var pointorigy = Number(Math.floor(point.y * ratioy ));
    //  var pointorigx = Number(Math.floor(point.x * ratiox ));
    //  var obj = {x:pointorigx>=0?pointorigx:0,y:pointorigy>=0?pointorigy:0};
      //setCoords(obj);
    //  return obj;
    //});
  
    //setPoint(pi);    
  }

  async function toDataURL(url) {
    const blob = await fetch(url).then(res => res.blob());
    return URL.createObjectURL(blob);
  }
  async function dwnl(){
    //const url = window.URL.createObjectURL(imageBlob);
    const a = document.createElement('a');
    a.style.display = 'none';
    //if(blob==null)
    a.href = await toDataURL(canvasobj.image.src);
    a.download = 'edited.png';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  
  /*if(show!==undefined)
    patchReady(show);*/

  return (
    <Box sx={{ width: dim }}>
      {!ready && (<ClockLoader color="#21ca1c" />)}
      <CanvasDraw 
          ref={setCanvasObj}
          onChange={changes} 
          canvasWidth={dim} 
          canvasHeight={dim} 
          imgSrc={src} 
          hideGrid 
          brushRadius={brush}
          backgroundColor={'transparent'} 
          brushColor="rgba(155,12,60,0.3)"/>
      {busy && (<ClockLoader color="#21ca1c" />)}
      <Typography gutterBottom>Brush size</Typography>
          <Slider aria-label="Brush size" min={4} max={50}
              value={brush}
              valueLabelDisplay="auto"
              onChange={(e) => setBrush(Number(e.target.value))}/>
      {!busy && (<Stack direction='row' spacing={4}>
        <Button component="label" tabIndex={-1} role={undefined} onClick={reset} 
              color={'primary'} variant="contained" startIcon={<AutoFixNormal/>}>reset</Button>
        <Button component="label" tabIndex={-1} role={undefined} onClick={clear} 
              color={'primary'} variant="contained" startIcon={<AutoFixNormal/>}>clear</Button>
        <Button component="label" tabIndex={-1} role={undefined} onClick={undo} 
              color={'primary'} variant="contained" startIcon={<AutoFixNormal/>}>undo</Button>
        
        <Button component="label" tabIndex={-1} role={undefined} onClick={submit} 
              color={'secondary'} variant="contained" startIcon={<AutoFixNormal/>}>inPaint
      </Button>

      <Button component="label" tabIndex={-1} role={undefined} onClick={dwnl} 
              color={'secondary'} variant="contained" startIcon={<AutoFixNormal/>}>download
      </Button>

      <Button component="label" tabIndex={-1} role={undefined} onClick={()=>window.open("https://gmicol.greyc.fr")} 
              color={'secondary'} variant="contained" startIcon={<AutoFixNormal/>}>editor
      </Button>
    
      </Stack>)
      }
    </Box>
  );
}

export default InpaintEditor;